/* Plaza — abre los dropdowns del header al hover en desktop.
   Dawn usa <details>/<summary> que es click-driven por design (la UA del browser
   oculta los hijos no-summary cuando no hay [open]). El intento CSS puro con
   :hover sobre `details` no muerde porque `display: none` aplicado por la UA
   no se override fiable con `display: block !important` en todos los browsers
   y porque el atributo [open] no se setea via :hover.

   Solución: en mouseenter sobre <header-menu> añadimos [open] al <details>
   interno. Dawn ya tiene CSS para `.mega-menu[open] .mega-menu__content
   { opacity: 1; transform: translateY(0) }` que se dispara automáticamente.
   En mouseleave quitamos [open] tras un delay corto (250ms) para que el
   cursor pueda viajar al panel sin perderlo. Si re-entra cancela el cierre.
   Solo aplica >=990px (mobile mantiene tap default). */

(() => {
  const MIN_DESKTOP = 990;
  const CLOSE_DELAY_MS = 250;

  function init() {
    if (window.innerWidth < MIN_DESKTOP) return;

    document.querySelectorAll('header-menu').forEach((wrapper) => {
      const details = wrapper.querySelector('details.mega-menu');
      if (!details) return;

      let closeTimer;

      const open = () => {
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          // Mantener aria-expanded en sync para a11y
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      };

      const scheduleClose = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY_MS);
      };

      // Hover sobre el wrapper completo (incluye summary y panel) abre.
      wrapper.addEventListener('mouseenter', open);
      wrapper.addEventListener('mouseleave', scheduleClose);

      // El panel también cancela el cierre cuando el cursor entra en él.
      const panel = details.querySelector('.mega-menu__content');
      if (panel) {
        panel.addEventListener('mouseenter', open);
        panel.addEventListener('mouseleave', scheduleClose);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-aplicar tras cambios en design mode del editor
  document.addEventListener('shopify:section:load', init);
})();
